import '../styles/Stories.css'
import Story from './Story';
import HorizontalScroll from "react-scroll-horizontal";


function Stories (){
    return (
        <div className="stories">
            <HorizontalScroll className='scroll' reverseScroll={true}>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>
                <Story/>

            </HorizontalScroll>
        </div>
    )
};
export default Stories;